// frontend/src/components/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Card, CardContent, Typography } from '@mui/material';
import api from '../services/api';
import Swal from 'sweetalert2'; // Importa o SweetAlert2

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await api.post('/login', 
        { username, password }, 
        {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        }
      );
      
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        navigate('/dashboard');
      }
    } catch (error) {
      // Exibe o alerta caso o login falhe
      Swal.fire({
        icon: 'error',
        title: 'Login falhou',
        text: 'Nome de usuário ou senha incorretos. Por favor, tente novamente!',
      });
    }
  };

  return (
    <Card style={{ maxWidth: 400, margin: 'auto', marginTop: '10%' }}>
      <CardContent>
        <Typography variant="h5" component="h2">Login</Typography>
        <TextField
          label="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          margin="normal"
        />
        <Button variant="contained" color="primary" onClick={handleLogin} fullWidth>Login</Button>
      </CardContent>
    </Card>
  );
};

export default Login;
